import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/**
 * PWA Page Wrapper - Umhüllt bestehende Seiten mit PWA-Header
 * Ermöglicht die Wiederverwendung aller Website-Seiten in der PWA
 */
const PWAPageWrapper = ({ children, title, showBackButton = true }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-white pb-20">
      {/* PWA Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="flex items-center h-14 px-4">
          {showBackButton && (
            <button 
              onClick={handleBack}
              className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full active:bg-gray-100"
            >
              <ChevronLeft size={24} className="text-gray-700" />
            </button>
          )}
          <h1 className={`flex-1 ${showBackButton ? 'text-center' : 'text-left'} font-bold text-lg text-gray-900`}>
            {title}
          </h1>
          {showBackButton && <div className="w-10" />}
        </div>
      </header>

      {/* Page Content - Remove default header/footer from wrapped pages */}
      <div className="pwa-page-content">
        {children}
      </div>
    </div>
  );
};

export default PWAPageWrapper;
